/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _moment = _interopRequireDefault(require("moment"));
var _default = function _default(value, dateFormat, config) {
  if ((0, _typeof2.default)(dateFormat) === 'object') {
    config = dateFormat;
    dateFormat = null;
  }
  var strict = !!(config && config.strict);
  var locale = config && config.locale;
  dateFormat = dateFormat || config && config.dateFormat || 'YYYY-MM-DD';
  if (typeof value == 'string') {
    return (0, _moment.default)(value, dateFormat, locale, strict);
  }
  value = value == null ? new Date() : value;
  return (0, _moment.default)(value, undefined, locale, strict);
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Calendar/src/toMoment.js
// module id = 40
// module chunks = 0